const color = {
  //using
  black: '#333333',
  white: '#FFFFFF',
  gray: '#A1A1A1',
  moreLightGray: '#eeeeee',
  lightGray: '#cbcbcb',
  veryLightGray:'#F2F2F2',
  transparent: '#00000000',

  //added
  darkGreen: '#148E93',
  darkGreenTrans: '#ffffff88',
  lightGreen: '#69FBFD',
  veryLightGreen: '#E9FEF8',
  cream: '#FBF7D8',
  empathPink: '#E44591',
  empathYellow: '#FAC42E',
  empathBlue: '#1AA7CB',
  empathGreen: '#0F7E3B',
}

//todo clean
export default {
  // common color
  themeColor: color.darkGreen,
  themeColorTrans: color.darkGreenTrans,
  lightThemeColor: color.lightGreen,
  veryLightThemeColor: color.veryLightGreen,
  transparent: color.transparent,

  // Empath color
  empathPink: color.empathPink,
  empathYellow: color.empathYellow,
  empathBlue: color.empathBlue,
  empathGreen: color.empathGreen,

  // background color
  whiteBackground: color.white,
  blackBackground: color.black,
  lightGrayBackGround: color.veryLightGray,

  // font color
  whiteFontColor: color.white,
  blackFontColor: color.black,
  grayFontColor: color.gray,

  // border color
  borderBlack: color.black,
  lightBorderColor: color.lightGray,

  // button color
  buttonGray: color.moreLightGray,
  buttonCream: color.cream,
};